var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPro15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Komponente_10_56",
    "data-name": "Komponente 10 \\u2013 56",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "supplementary-food",
    transform: "translate(-16 -16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46750",
    "data-name": "Pfad 46750",
    d: "M81.067,58.133H102.4a1.067,1.067,0,0,0,0-2.133H81.067a1.067,1.067,0,0,0,0,2.133Z",
    transform: "translate(-55.467 -34.667)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46751",
    "data-name": "Pfad 46751",
    d: "M73.6,44.284v-3.5A3.192,3.192,0,0,0,74.667,38.4V36.267a3.2,3.2,0,0,0-3.2-3.2H60.8a3.2,3.2,0,0,0-3.2,3.2V38.4a3.192,3.192,0,0,0,1.067,2.383v3.5a9.606,9.606,0,0,0-3.1,1.819l.97-24.727c0-.013,0-.028,0-.042V17.067A1.067,1.067,0,0,0,55.467,16h-38.4A1.067,1.067,0,0,0,16,17.067v4.267c0,.013,0,.028,0,.042l2.133,54.4a1.067,1.067,0,0,0,.76.98C19.335,76.887,29.8,80,37.333,80c6.25,0,13.094-2.135,15.495-2.956A5.338,5.338,0,0,0,57.6,80H74.667A5.339,5.339,0,0,0,80,74.667V53.333a9.615,9.615,0,0,0-6.4-9.05ZM59.733,36.267A1.068,1.068,0,0,1,60.8,35.2H71.467a1.068,1.068,0,0,1,1.067,1.067V38.4a1.068,1.068,0,0,1-1.067,1.067H60.8A1.068,1.068,0,0,1,59.733,38.4ZM60.8,41.6H71.467v2.194a9.652,9.652,0,0,0-1.067-.061H61.867a9.652,9.652,0,0,0-1.067.061Zm-6.4,32V55.467H77.867V73.6ZM37.333,77.867c-6.116,0-14.586-2.241-17.1-2.946L18.218,23.467h3.115a1.067,1.067,0,0,0,0-2.133h-3.2v-3.2H54.4v3.2H51.2a1.067,1.067,0,0,0,0,2.133h3.115l-1,25.513a9.537,9.537,0,0,0-1.049,4.354V74.667c0,.1,0,.207.01.309C50.133,75.709,43.322,77.867,37.333,77.867Zm37.333,0H57.6a3.205,3.205,0,0,1-3.017-2.133h23.1a3.205,3.205,0,0,1-3.017,2.133ZM54.4,53.333a7.475,7.475,0,0,1,7.467-7.467H70.4a7.475,7.475,0,0,1,7.467,7.467Z",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46752",
    "data-name": "Pfad 46752",
    d: "M341.869,331.2H337.6c-.061,0-.123,0-.183.006V331.2a3.2,3.2,0,0,0-5.463-2.263l-1.508,1.508h0l-1.508,1.508a3.2,3.2,0,1,0,4.524,4.527l1.093-1.093A3.205,3.205,0,0,0,337.6,337.6h4.267a3.2,3.2,0,0,0,0-6.4Zm-8.4-.754a1.067,1.067,0,1,1,1.508,1.508l-.754.754L332.71,331.2l.754-.754Zm-3.017,4.526a1.068,1.068,0,0,1,0-1.509l.754-.754,1.509,1.508-.754.754A1.068,1.068,0,0,1,330.448,334.971Zm6.087-.571a1.068,1.068,0,0,1,1.067-1.067h1.067v2.133H337.6A1.068,1.068,0,0,1,336.535,334.4Zm5.333,1.067H340.8v-2.133h1.067a1.067,1.067,0,0,1,0,2.133Z",
    transform: "translate(-270.402 -270.4)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46753",
    "data-name": "Pfad 46753",
    d: "M373.333,416h-4.267a1.067,1.067,0,1,0,0,2.133h4.267a1.067,1.067,0,1,0,0-2.133Z",
    transform: "translate(-305.067 -346.667)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46754",
    "data-name": "Pfad 46754",
    d: "M157.333,354.133a1.067,1.067,0,0,0,0-2.133h-4.267a1.067,1.067,0,0,0,0,2.133Z",
    transform: "translate(-117.867 -291.2)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46755",
    "data-name": "Pfad 46755",
    d: "M133.867,384h-12.8a1.067,1.067,0,0,0,0,2.133h12.8a1.067,1.067,0,0,0,0-2.133Z",
    transform: "translate(-90.133 -318.933)",
    fill: "#2ecf96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_46756",
    "data-name": "Pfad 46756",
    d: "M84.706,129.235A3.176,3.176,0,0,0,82.18,128H78.929a3.2,3.2,0,1,0,0,6.4H81.2c.261,2.289.225,5.519-.856,6.672a11.315,11.315,0,0,0-2.483-.272,10.27,10.27,0,0,0-5.9,1.765,5.333,5.333,0,1,0,0,9.271,10.732,10.732,0,0,0,11.792,0,5.332,5.332,0,0,0,2.638.7h.045a5.224,5.224,0,0,0,3.785-1.665,5.505,5.505,0,0,0,1.5-3.846C91.656,139.04,86.793,131.924,84.706,129.235Zm3.969,20.17a3.138,3.138,0,0,1-3.288.833c.081-.114.16-.23.232-.348a1.067,1.067,0,1,0-1.82-1.113c-1,1.634-3.329,2.69-5.935,2.69s-4.936-1.056-5.935-2.69a1.067,1.067,0,1,0-1.82,1.113c.072.118.15.233.231.347a3.2,3.2,0,1,1,0-6.074c-.081.114-.159.229-.231.347a1.067,1.067,0,0,0,1.82,1.113c1-1.634,3.329-2.69,5.935-2.69a8.429,8.429,0,0,1,3.976.94,1.067,1.067,0,1,0,1.009-1.88c-.131-.071-.267-.137-.4-.2,1.639-2.811.842-7.993.735-8.634a1.067,1.067,0,0,0-1.052-.891h-3.2a1.067,1.067,0,1,1,0-2.133H82.18a1.057,1.057,0,0,1,.841.41c1.525,1.965,6.507,8.96,6.575,16.5a3.382,3.382,0,0,1-.921,2.363Z",
    transform: "translate(-41.596 -97.067)",
    fill: "#2ecf96"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_35490",
    "data-name": "Gruppe 35490",
    transform: "translate(-320 -2887)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_555",
    "data-name": "Ellipse 555",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(364 2931)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_554",
    "data-name": "Ellipse 554",
    transform: "translate(367 2934)",
    fill: "#fff",
    stroke: "#2ecf96",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-thumbs-up",
    "data-name": "Icon ionic-ios-thumbs-up",
    d: "M15.1,13.208a1.171,1.171,0,0,0,.482-.906,1.266,1.266,0,0,0-.314-.839c-.017-.035-.032-.066-.046-.1l-.006-.032a.376.376,0,0,1,.058-.288,1.264,1.264,0,0,0,.167-.741.876.876,0,0,0-.28-.669.55.55,0,0,1-.118-.528,1.112,1.112,0,0,0-.236-1.09c-.3-.34-.585-.381-1.338-.337-.519.032-1.6.2-2.313.311-.291.046-.545.087-.623.092-.366.037-.438,0-.473-.141a.935.935,0,0,1,.141-.375,6.185,6.185,0,0,0,.418-1.032,3.623,3.623,0,0,0-.078-2.6.942.942,0,0,0-.758-.551,1.147,1.147,0,0,0-.8.228c-.1.115-.066.335-.179.773a8.409,8.409,0,0,1-.346,1.211A8.289,8.289,0,0,1,6.81,7.336c-.118.1-.219.193-.291.262a5.944,5.944,0,0,0-.735.943,5.02,5.02,0,0,1-.4.534,1.042,1.042,0,0,1-.643.314.231.231,0,0,0-.231.231v4.6a.239.239,0,0,0,.239.239,4.545,4.545,0,0,1,1.915.34,4.984,4.984,0,0,0,1.338.349,27.7,27.7,0,0,0,3.247.234,14.373,14.373,0,0,0,1.632-.112c.894-.1,1.851-.311,2.169-1.067a.814.814,0,0,0-.014-.683.227.227,0,0,1-.023-.075A.244.244,0,0,1,15.1,13.208Z",
    transform: "translate(368.952 2936.118)",
    fill: "#2ecf96"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPro15);
export default __webpack_public_path__ + "static/media/Pro15.4ee2335262791d5737037ea2ddabbede.svg";
export { ForwardRef as ReactComponent };